import { Star, Quote } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { Testimonial } from '@/types';

interface TestimonialCardProps {
  testimonial: Testimonial;
  className?: string;
}

export function TestimonialCard({ testimonial, className }: TestimonialCardProps) {
  return (
    <div className={cn('card-kuiva relative', className)}>
      <Quote className="absolute right-3 top-3 h-6 w-6 text-kuiva-green/25 sm:right-4 sm:top-4 sm:h-7 sm:w-7" />

      <div className="mb-3 flex items-center gap-2.5 sm:gap-3">
        <div className="h-10 w-10 overflow-hidden rounded-full bg-kuiva-light sm:h-11 sm:w-11">
          {testimonial.photo ? (
            <img
              src={testimonial.photo}
              alt={testimonial.name}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-kuiva-blue to-kuiva-green text-white font-semibold">
              {testimonial.name.charAt(0)}
            </div>
          )}
        </div>
        <div>
          <h4 className="text-sm font-semibold text-foreground sm:text-base">{testimonial.name}</h4>
          <div className="flex items-center gap-1">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star
                key={i}
                className={cn(
                  'w-3 h-3',
                  i < testimonial.rating
                    ? 'fill-yellow-400 text-yellow-400'
                    : 'text-gray-300'
                )}
              />
            ))}
          </div>
        </div>
      </div>
      
      <p className="mb-2 text-sm leading-relaxed text-foreground-secondary sm:text-[0.9375rem]">
        &ldquo;{testimonial.text}&rdquo;
      </p>
      
      {testimonial.professionalName && (
        <p className="text-sm text-muted-foreground">
          Com {testimonial.professionalName}
        </p>
      )}
    </div>
  );
}
